// src/pages/FeedbackPage.jsx
import React from 'react';
import PageHeader from './PageHeader';
import { useLanguage } from '../../context/LanguageContext';
import { FaStar, FaQuoteLeft } from 'react-icons/fa';

const FeedbackPage = () => {
  const { language } = useLanguage();

  const t = {
    English: {
      pageHeaderTitle: "Feedback",
      title: "We Value Your Feedback",
      subtitle: "Help us improve ST MatchZone by sharing your thoughts and suggestions.",
      formTitle: "Submit Your Feedback",
      name: "Your Name",
      email: "Your Email",
      message: "Your Message",
      submit: "Submit Feedback",
      thanks: "Thank you for your valuable feedback! It helps us serve you better."
    },
    Tamil: {
      pageHeaderTitle: "கருத்து",
      title: "உங்கள் கருத்தை மதிக்கிறோம்",
      subtitle: "உங்கள் எண்ணங்களையும் பரிந்துரைகளையும் பகிர்ந்து ST MatchZone-ஐ மேம்படுத்த உதவுங்கள்.",
      formTitle: "உங்கள் கருத்தை சமர்ப்பிக்கவும்",
      name: "உங்கள் பெயர்",
      email: "உங்கள் மின்னஞ்சல்",
      message: "உங்கள் செய்தி",
      submit: "கருத்தை சமர்ப்பிக்கவும்",
      thanks: "உங்கள் மதிப்புமிக்க கருத்துக்கு நன்றி! இது எங்களை சிறப்பாக சேவை செய்ய உதவுகிறது."
    }
  };

  const txt = t[language];

  return (
    <div className="min-h-screen bg-gray-50">
      <PageHeader showBackButton={true} backTo="/" title={txt.pageHeaderTitle} />

      <div className="container mx-auto px-6 py-16">
        <div className="text-center max-w-4xl mx-auto mb-16">
          <img src="https://www.wikihow.com/images/thumb/0/0f/Live-a-Happy-Married-Life-Step-23.jpg/v4-1200px-Live-a-Happy-Married-Life-Step-23.jpg" alt="Happy Couple Feedback" className="w-full h-96 object-cover rounded-2xl shadow-xl mb-10" />
          <h1 className="text-4xl md:text-5xl font-black text-gray-900 mb-4">{txt.title}</h1>
          <p className="text-xl text-gray-600">{txt.subtitle}</p>
        </div>

        <div className="max-w-2xl mx-auto bg-white rounded-2xl shadow-xl p-10">
          <h2 className="text-3xl font-bold text-center mb-8 flex items-center justify-center gap-4">
            <FaQuoteLeft className="text-rose-600" /> {txt.formTitle}
          </h2>
          <form className="space-y-6">
            <input type="text" placeholder={txt.name} className="w-full px-6 py-4 border border-gray-300 rounded-xl focus:outline-none focus:border-rose-500" />
            <input type="email" placeholder={txt.email} className="w-full px-6 py-4 border border-gray-300 rounded-xl focus:outline-none focus:border-rose-500" />
            <textarea rows="6" placeholder={txt.message} className="w-full px-6 py-4 border border-gray-300 rounded-xl focus:outline-none focus:border-rose-500"></textarea>
            <button type="submit" className="w-full py-4 bg-gradient-to-r from-rose-500 to-pink-500 text-white font-bold rounded-xl hover:shadow-lg transition">{txt.submit}</button>
          </form>
          <p className="text-center mt-8 text-gray-600 italic">{txt.thanks}</p>
        </div>
      </div>
    </div>
  );
};

export default FeedbackPage;